const thenify = (type: string, readyState: RegExp) =>
  new Promise((resolve) => {
    const listener = () => {
      if (readyState.test(document.readyState)) {
        document.removeEventListener(type, listener);
        resolve(undefined);
      }
    };
    document.addEventListener(type, listener);
    listener();
  });

export const parsed = thenify('readystatechange', /^(?:interactive|complete)$/);
export const contentLoaded = thenify('DOMContentLoaded', /^(?:interactive|complete)$/);
export const loaded = thenify('readystatechange', /^complete$/);
